import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import isEqual from 'react-fast-compare';
import type { AppDispatch, RootState } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = (
  selector,
  equalityFn = isEqual
) => useSelector(selector, equalityFn);
